import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from './core/services/loader.service';
import { LocalStorage } from '@core/localstorage';

@Component({
    selector: 'app-base',
    templateUrl: './app-base.component.html',
    styles: [
        `
            nb-layout,
            nb-layout-column {
                padding: 0 !important;
            }

            ::ng-deep .layout-container > .content {
                padding: 0;
            }
        `,
    ],
})
export class AppBaseComponent implements OnInit {
    title = 'Tennistool';
    layout: any;
    token: string;

    constructor(private route: ActivatedRoute, public loaderService: LoaderService, public localStorage: LocalStorage) {
        this.token = this.localStorage.getToken();
    }

    ngOnInit() {
        const { data } = this.route.snapshot.data;

        this.layout = data && data.layout;
    }
}
